module.exports = __webpack_public_path__ + "static/media/path3.26b827a5.jpg";